// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DingtalkOutlinedSvg from "@ant-design/icons-svg/es/asn/DingtalkOutlined";
import AntdIcon from '../components/AntdIcon';

var DingtalkOutlined = function DingtalkOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkOutlinedSvg
  }));
};

DingtalkOutlined.displayName = 'DingtalkOutlined';
export default React.forwardRef(DingtalkOutlined);